[].slice.call(document.querySelectorAll('.video-container button:not(.video-controls)')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var parent = this.parentNode.parentNode,
			thumbnail = parent.querySelector('.thumbnail'),
			video = parent.querySelector('figure.video > *:first-child');

		if(thumbnail)
			Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

		playVideo(video);
	});
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;

	video.src = src.replace('?autoplay=1&rel=0&title=false&color=42C4D8', '');
}

// Play/Pause Background Video
[].slice.call(document.querySelectorAll('.video-container .video-controls')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var videoPaused = this.classList.contains('play'),
			video = this.parentNode.querySelector('.video-element');

		if(videoPaused)
			video.play();
		else
			video.pause();

		this.classList.toggle('play');

		this.setAttribute('aria-label', (videoPaused ? 'Pause' : 'Play') + ' Video');
	});
});